import * as yup from "yup";
import { validationNotEmpty, } from "./defaultValidations";

export default yup.object({
  planName: validationNotEmpty("Plan Name"),
  price: validationNotEmpty("Price"),
  planCode: validationNotEmpty("Plan Code"),
  planDescription: validationNotEmpty("Plan Description"),
});
